module.exports = __webpack_public_path__ + "img/meet.9dfae4aa.png";